exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a[data-v-07d04486]{text-decoration:none}", ""]);

